import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCookie, removeCookie } from '../utils/helper';
import { checkMyPermission } from '../services/apiAuth';

const PERMISSION_CHECK_INTERVAL = 60 * 30 * 1000;

const usePermissionCheck = () => {
  const navigate = useNavigate();
  const isCheckingRef = useRef(false);

  useEffect(() => {
    const token = getCookie('token');
    if (!token) return;

    const checkPermission = async () => {
      if (isCheckingRef.current) return;
      isCheckingRef.current = true;

      try {
        const serverUser = await checkMyPermission();
        const localToken = getCookie('token');

        if (!serverUser) {
          isCheckingRef.current = false;
          return;
        }

        if (!localToken) {
          isCheckingRef.current = false;
          return;
        }

        if (Number(serverUser.permission) !== Number(localToken.permission)) {
          console.warn('[permission] Quyền đã thay đổi:', {
            local: localToken.permission,
            server: serverUser.permission,
          });
          removeCookie('token');
          removeCookie('token_sv');
          removeCookie('exp_sv');
          alert('Tài khoản của bạn đã bị thay đổi quyền. Vui lòng đăng nhập lại.');
          navigate('/login', { replace: true });
          window.location.reload();
          return;
        }

        if (serverUser.username && localToken.username && serverUser.username !== localToken.username) {
          console.warn('[permission] Username đã thay đổi');
          removeCookie('token');
          removeCookie('token_sv');
          removeCookie('exp_sv');
          alert('Tài khoản không hợp lệ. Vui lòng đăng nhập lại.');
          navigate('/login', { replace: true });
          window.location.reload();
        }
      } catch (err) {
        console.warn('[permission] Check thất bại:', err);
      } finally {
        isCheckingRef.current = false;
      }
    };

    const timeout = setTimeout(checkPermission, 2000);
    const interval = setInterval(checkPermission, PERMISSION_CHECK_INTERVAL);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') checkPermission();
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [navigate]);
};

export default usePermissionCheck;
